import React from 'react';
import { cn } from '@bem-react/classname';
import { DeleteIcon } from '@lms-elements/icons';

import { NoteActions } from '../NoteActions';

import { PopupProps } from './Popup.types';

import './Popup.scss';

const CnPopup = cn('popup-principal');

export const Popup: React.FC<PopupProps> = ({ isMobile, onCloseClick, onChangeSend }) => {
    return (
        <div className={CnPopup()}>
            <div className={CnPopup('note-wrapper', { isMobile })}>
                <div className={CnPopup('close-button')} onClick={onCloseClick}>
                    <DeleteIcon />
                </div>
                <NoteActions
                    title={'Написать директору'}
                    isLetter={true}
                    name={'select'}
                    titlePlaceholder={'Тема'}
                    placeholder={'Сообщение'}
                    titleName={'title'}
                    id={1}
                    onChangeSend={onChangeSend}
                    onClickCancel={onCloseClick}
                />
            </div>
        </div>
    );
};
